<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <!-- 收益统计卡片 -->
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              title="昨日收益"
              :value="loading ? '加载中...' : formatAmount(summary.yesterday)"
              description="截至昨日 23:59"
              :icon="{
                component: 'ni ni-money-coins',
                background: 'bg-gradient-warning',
                shape: 'rounded-circle'
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              title="今日收益"
              :value="loading ? '加载中...' : formatAmount(summary.today)"
              description="实时更新"
              :icon="{
                component: 'ni ni-chart-bar-32',
                background: 'bg-gradient-primary',
                shape: 'rounded-circle'
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              title="近7日收益"
              :value="loading ? '加载中...' : formatAmount(summary.week7)"
              description="最近7天累计"
              :icon="{
                component: 'ni ni-calendar-grid-58',
                background: 'bg-gradient-success',
                shape: 'rounded-circle'
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card
              title="近30日收益"
              :value="loading ? '加载中...' : formatAmount(summary.day30)"
              description="最近30天累计"
              :icon="{
                component: 'ni ni-credit-card',
                background: 'bg-gradient-danger',
                shape: 'rounded-circle'
              }"
            />
          </div>
        </div>

        <!-- 折线图：数据就绪后才挂载，确保 Chart.js 拿到真实数据 -->
        <div class="row mt-4">
          <div class="col-12">
            <gradient-line-chart
              v-if="chartReady"
              id="revenue-chart"
              title="近30日收益趋势"
              :description="chartDescription"
              :chart="chartData"
            />
            <div v-else class="card z-index-2">
              <div class="pb-0 card-header mb-0">
                <h6>近30日收益趋势</h6>
              </div>
              <div class="p-3 card-body text-center py-5">
                <span class="text-muted text-sm">
                  {{ loading ? '图表加载中...' : (error ? '图表加载失败' : '暂无数据') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 错误提示 -->
        <div v-if="error" class="row mt-3">
          <div class="col-12">
            <div class="alert alert-danger text-white" role="alert">
              数据加载失败：{{ error }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MiniStatisticsCard from "../../examples/Cards/MiniStatisticsCard.vue";
import GradientLineChart from "../../examples/Charts/GradientLineChart.vue";
import { fetchRevenueSummary, fetchRevenueList } from "../../api/index.js";

export default {
  name: "DashboardDefault",
  components: {
    MiniStatisticsCard,
    GradientLineChart,
  },
  data() {
    return {
      loading: true,
      error: null,
      chartReady: false,
      summary: {
        yesterday: 0,
        today: 0,
        week7: 0,
        day30: 0,
      },
      chartData: {
        labels: [],
        datasets: [{ label: "日收益", data: [] }],
      },
    };
  },
  computed: {
    chartDescription() {
      return `近30天累计收益 <span class='font-weight-bold'>${this.formatAmount(this.summary.day30)}</span>`;
    },
  },
  async created() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.error = null;
      this.chartReady = false;
      try {
        const [summaryData, listData] = await Promise.all([
          fetchRevenueSummary(),
          fetchRevenueList({ days: 30 }),
        ]);
        this.summary = summaryData;
        const rows = listData && listData.data;
        if (rows && rows.length > 0) {
          // 按日期聚合：同一天多个网站/广告位的分成后收益求和
          const byDate = {};
          rows.forEach((r) => {
            byDate[r.date] = (byDate[r.date] || 0) + (r.post_share_revenue || 0);
          });
          const sortedDates = Object.keys(byDate).sort();
          this.chartData = {
            labels: sortedDates,
            datasets: [{ label: "分成后收益", data: sortedDates.map((d) => byDate[d]) }],
          };
          this.chartReady = true;
        }
      } catch (e) {
        console.error("[Dashboard] 数据加载失败:", e);
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    formatAmount(val) {
      if (!val && val !== 0) return "$0.00";
      return (
        "$" +
        Number(val).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    },
  },
};
</script>
